import { render, staticRenderFns } from "./invoice-fee.vue?vue&type=template&id=81505f4c&scoped=true&"
import script from "./invoice-fee.vue?vue&type=script&lang=js&"
export * from "./invoice-fee.vue?vue&type=script&lang=js&"
import style0 from "./invoice-fee.vue?vue&type=style&index=0&id=81505f4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81505f4c",
  null
  
)

export default component.exports